import DomainCommon from './common';

const MissionService = {
    list: (params) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission?${DomainCommon.buildQueryString(params)}`,
                resolve, reject
            });
        });
    },
    listForAdmin: params => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission?${DomainCommon.buildQueryString(params)}`,
                resolve, reject
            });
        });
    },
    findById: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}`,
                resolve, reject
            });
        });
    },
    findByIdForInstitution: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}`,
                resolve, reject
            });
        });
    },
    getMonthlyData: (year = new Date().getFullYear()) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/monthlyData/${year}`,
                resolve, reject
            });
        });
    },
    openChatRoom: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/openChatRoom`,
                resolve, reject
            });
        });
    },
    openChatRoomByAdminMedical: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}/openChatRoom`,
                resolve, reject
            });
        });
    },
    fail: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/fail`,
                resolve, reject
            });
        });
    },
    failByAdminMedical: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}/fail`,
                resolve, reject
            });
        });
    },
    finish: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/finish`,
                resolve, reject
            });
        });
    },
    finishByAdminMedical: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}/finish`,
                resolve, reject
            });
        });
    },
    cancel: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/cancel`,
                resolve, reject
            });
        });
    },
    cancelByAdminMedical: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}/cancel`,
                resolve, reject
            });
        });
    },
    postNotice: ({id, medicalSuggest}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${id}/notice`,
                jsonBody: {medicalSuggest},
                resolve, reject
            });
        });
    },
    postNoticeByAdminMedical: ({id, medicalSuggest}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${id}/notice`,
                jsonBody: {medicalSuggest},
                resolve, reject
            });
        });
    },
    getArchives: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/archives`,
                resolve, reject
            });
        });
    },
    getArchivesByAdminMedical: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/${missionId}/archives`,
                resolve, reject
            });
        });
    },
    exportMission: ({identity, livingArea, missionType, missionStatus, dateFrom, dateTo}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/exportMission`,
                jsonBody: {identity, livingArea, missionType, missionStatus, dateFrom, dateTo},
                resolve, reject
            });
        });
    },
    exportMissionAdminMedical: ({identity, livingArea, missionType, missionStatus, dateFrom, dateTo}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/mission/exportMission`,
                jsonBody: {identity, livingArea, missionType, missionStatus, dateFrom, dateTo},
                resolve, reject
            });
        });
    },
    modifyReservationTime: ({ reservationMissionId, date, startTime, endTime }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/reservationMission/${reservationMissionId}/updateReservationDateTime`,
                jsonBody: {date, startTime, endTime},
                resolve, reject
            });
        });
    },
    modifyReservationTimeForAm: ({ reservationMissionId, date, startTime, endTime }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/reservationMission/${reservationMissionId}/updateReservationDateTime`,
                jsonBody: {date, startTime, endTime},
                resolve, reject
            });
        });
    },
    changePatient: ({ missionId, vipId }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/changePatient`,
                jsonBody: { vipId },
                resolve, reject
            })
        })
    }
};

export default MissionService;



// WEBPACK FOOTER //
// ./src/service/mission.js